import { Checkbox } from 'primereact/checkbox';
import { Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { bankAccountRegex } from '../../../../../../../utils/constants/regex';
import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors';
import { FormValues } from '../../CreateEditDialog.functions';

function CodBankAccountPaymentField() {
  const { t } = useTranslation();

  const smetka = useWatch<FormValues, 'smetka'>({
    name: 'smetka',
  });

  const isBankAccountValid = bankAccountRegex.test(smetka ?? '');

  return (
    <FieldWithErrors
      name="cod_bank_account_payment"
      label={false}
      className="p-d-flex p-mb-2 p-jc-between"
    >
      <Controller
        name="cod_bank_account_payment"
        render={({ field }) => (
          <>
            <Checkbox
              id="cod_bank_account_payment"
              name="cod_bank_account_payment"
              checked={field.value}
              value={field.value}
              onChange={field.onChange}
              className="data-cy-cod_bank_account_payment"
              disabled={!isBankAccountValid}
              tooltip={
                smetka && smetka.length > 0
                  ? !isBankAccountValid
                    ? t('Invalid bank account number')
                    : ''
                  : t('No bank account specified')
              }
            />
            <label
              htmlFor="cod_bank_account_payment"
              data-cy="cod_bank_account_payment"
            >
              {t('Receive COD on bank account')}
            </label>
          </>
        )}
      />
    </FieldWithErrors>
  );
}

export default CodBankAccountPaymentField;
